var _rect, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultYachtClubFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 96,
    viewBox: "0 0 160 96",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Default yacht club flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 96,
    fill: "#f7fafc"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h126l-33 40 33 40H8z",
    fill: "#17456b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8h59l-24 40 24 40H8z",
    fill: "#3cb7a6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14h113l-28 34 28 34H8z",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 48,
    r: 14,
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v34M33 48h34",
    stroke: "#17456b",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultYachtClubFlag);
export default __webpack_public_path__ + "static/media/default-yacht-club-flag.a4ef9007d7a6145514ed067ae7eb3e42.svg";
export { ForwardRef as ReactComponent };